import { render, staticRenderFns } from "./UserProps.vue?vue&type=template&id=35b0e040&"
import script from "./UserProps.vue?vue&type=script&lang=js&"
export * from "./UserProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports